import React from 'react';
import './Paginacao.css';

const Paginacao = (props) => {
  // Suporte a props em EN e PT para retrocompatibilidade
  const totalItems = Number(
    props.totalItems ?? props.totalItens ?? 0
  );
  const itemsPerPageRaw = Number(
    props.itemsPerPage ?? props.itensPorPagina ?? 10
  );
  const itemsPerPage = itemsPerPageRaw > 0 ? itemsPerPageRaw : 10; // evita divisão por zero
  const currentPage = Number(
    props.currentPage ?? props.paginaAtual ?? 1
  );
  const onPageChange = props.onPageChange ?? props.setPaginaAtual ?? (() => {});

  const totalPaginas = Math.ceil(totalItems / itemsPerPage);

  if (totalPaginas <= 1) {
    return null; // Não renderiza se não houver páginas suficientes
  }

  const irParaPagina = (pagina) => {
    if (pagina >= 1 && pagina <= totalPaginas) {
      onPageChange(pagina);
    }
  };

  const renderizarNumerosPagina = () => {
    const paginas = [];
    const maxPaginasVisiveis = 7; // Total de botões de página visíveis (inclui elipses)
    const paginasVizinhas = 2; // Páginas antes e depois da página atual

    if (totalPaginas <= maxPaginasVisiveis) {
      // Se o total de páginas for pequeno, mostra todos os números
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(
          <button
            key={i}
            onClick={() => irParaPagina(i)}
            className={`pagination-button ${currentPage === i ? 'active' : ''}`}
          >
            {i}
          </button>
        );
      }
    } else {
      // Lógica para muitas páginas
      // Adiciona a primeira página
      paginas.push(
        <button
          key={1}
          onClick={() => irParaPagina(1)}
          className={`pagination-button ${currentPage === 1 ? 'active' : ''}`}
        >
          1
        </button>
      );

      // Adiciona elipse inicial se necessário
      if (currentPage > paginasVizinhas + 2) {
        paginas.push(<span key="start-ellipsis" className="pagination-ellipsis">...</span>);
      }

      // Adiciona páginas ao redor da atual
      const inicio = Math.max(2, currentPage - paginasVizinhas);
      const fim = Math.min(totalPaginas - 1, currentPage + paginasVizinhas);

      for (let i = inicio; i <= fim; i++) {
        paginas.push(
          <button
            key={i}
            onClick={() => irParaPagina(i)}
            className={`pagination-button ${currentPage === i ? 'active' : ''}`}
          >
            {i}
          </button>
        );
      }

      // Adiciona elipse final se necessário
      if (currentPage < totalPaginas - paginasVizinhas - 1) {
        paginas.push(<span key="end-ellipsis" className="pagination-ellipsis">...</span>);
      }

      // Adiciona a última página
      paginas.push(
        <button
          key={totalPaginas}
          onClick={() => irParaPagina(totalPaginas)}
          className={`pagination-button ${currentPage === totalPaginas ? 'active' : ''}`}
        >
          {totalPaginas}
        </button>
      );
    }

    return paginas;
  };

  return (
    <div className="pagination-container">
      <button
        onClick={() => irParaPagina(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-button"
      >
        Anterior
      </button>
      {renderizarNumerosPagina()}
      <button
        onClick={() => irParaPagina(currentPage + 1)}
        disabled={currentPage === totalPaginas}
        className="pagination-button"
      >
        Próxima
      </button>
    </div>
  );
};

export default Paginacao;
